import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import ContentWrapper from '@vio/atlas/helpers/ContentWrapper';
import { Flex } from '@vio/atlas/helpers/Flex';
import { PageWidthContainer } from '@vio/atlas/helpers/PageWidthContainer';
import { Text } from '@vio/atlas/Text';
import { TrustpilotWidget } from '@vio/shared/src/search/footer/TrustpilotWidget';
import { HomePageSectionTitle } from '../commonStyles';
import { HighlightedTitle } from '../HighlightedTitle';
const _exp = /*#__PURE__*/() => ContentWrapper;
const LayoutWrapper = /*#__PURE__*/styled(_exp())({
  name: "LayoutWrapper",
  class: "l1pzx3h5",
  propsAsIs: true
});
const _exp7 = /*#__PURE__*/() => ContentWrapper;
const LeftContentWrapper = /*#__PURE__*/styled(_exp7())({
  name: "LeftContentWrapper",
  class: "l1hki45s",
  propsAsIs: true
});
const _exp9 = /*#__PURE__*/() => ContentWrapper;
const TrustPilotWidgetContainer = /*#__PURE__*/styled(_exp9())({
  name: "TrustPilotWidgetContainer",
  class: "ttysnpk",
  propsAsIs: true
});
const supports = defineMessages({
  realTravelExpertsTitle: {
    id: 'homePage.supportRealTravelExpertsTitle',
    defaultMessage: 'Real travel experts'
  },
  realTravelExpertsSubtitle: {
    id: 'support.RealTravelExpertsSubtitle',
    defaultMessage: "We've been there, done it, got the T-shirt."
  },
  alwaysThereForYouTitle: {
    id: 'homePage.supportAlwaysThereForYouTitle',
    defaultMessage: 'Always there for you'
  },
  alwaysThereForYouSubtitle: {
    id: 'homePage.supportAlwaysThereForYouSubtitle',
    defaultMessage: 'Our response times are among the fastest in the industry.'
  },
  efficientAnEffectiveTitle: {
    id: 'homePage.supportEfficientAnEffectiveTitle',
    defaultMessage: 'Efficient and effective'
  },
  efficientAnEffectiveSubtitle: {
    id: 'homePage.supportEfficientSubtitle',
    defaultMessage: "We do the hard work, so you don't have to."
  }
});
const supportPerks = [{
  title: supports.realTravelExpertsTitle,
  subtitle: supports.realTravelExpertsSubtitle
}, {
  title: supports.alwaysThereForYouTitle,
  subtitle: supports.alwaysThereForYouSubtitle
}, {
  title: supports.efficientAnEffectiveTitle,
  subtitle: supports.efficientAnEffectiveSubtitle
}];
const CheckIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <rect width={20} height={20} fill="#3E9C32" rx={10} />
    <path fill="#fff" fillRule="evenodd" d="M15.013 6.165c.242.226.25.6.017.834l-6.753 6.82a.617.617 0 0 1-.89-.014l-2.431-2.623A.578.578 0 0 1 5 10.348a.62.62 0 0 1 .858.044l1.994 2.152 6.3-6.363a.62.62 0 0 1 .86-.016Z" clipRule="evenodd" />
  </svg>;
export const SupportSection = () => {
  const {
    isMobile
  } = useDeviceLayout();
  const {
    formatMessage
  } = useIntl();
  const ResponsiveRowOrColumn = isMobile ? Flex.Column : Flex.Row;
  return <PageWidthContainer>
      <LayoutWrapper paddingX="s600">
        <ResponsiveRowOrColumn gap="s700">
          <LeftContentWrapper paddingTop={isMobile ? 's000' : 's950'}>
            <TrustPilotWidgetContainer paddingBottom="s600">
              <TrustpilotWidget variant="horizontal" />
            </TrustPilotWidgetContainer>
            <HomePageSectionTitle variant={isMobile ? 'titleXL' : 'title4XL'}>
              <HighlightedTitle source="ExceptionalCustomerSupport" />
            </HomePageSectionTitle>
            <ContentWrapper paddingTop="s800" paddingBottom={isMobile ? 's000' : 's950'}>
              <Flex.Column gap="s700">
                {supportPerks.map((perk, index) => <Flex.Row key={index} gap="s500">
                    <ContentWrapper paddingTop="s200">
                      <CheckIcon />
                    </ContentWrapper>
                    <div>
                      <Text variant="titleL">{formatMessage(perk.title)}</Text>
                      <Text variant="bodyM">
                        {formatMessage(perk.subtitle)}
                      </Text>
                    </div>
                  </Flex.Row>)}
              </Flex.Column>
            </ContentWrapper>
          </LeftContentWrapper>

          <ContentWrapper>
            <Flex.Column gap="s700">
              <Flex.Row gap="s700">
                <img src="/static/support-section/support-1.jpg" width={160} alt="Vio.com customer support" />
                <img src="/static/support-section/support-2.jpg" width={352} alt="Vio.com customer support" />
              </Flex.Row>
              <Flex.Row gap="s700">
                <img src="/static/support-section/support-3.jpg" width={352} alt="Vio.com customer support" />
                <img src="/static/support-section/support-4.jpg" width={160} alt="Vio.com customer support" />
              </Flex.Row>
            </Flex.Column>
          </ContentWrapper>
        </ResponsiveRowOrColumn>
      </LayoutWrapper>
    </PageWidthContainer>;
};

require("./SupportSection.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SupportSection.tsx");